import { Button } from '@distribusion/owl-frontend-ui'
import React, { ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'

import { POPUP_TYPES, POPUP_OUTCOMES } from '@constants/popupTypes'
import useMoovitIntegration from '@hooks/useMoovitIntegration'
import { usePopupAnalytics } from '@hooks/usePopupAnalytics'
import { useTranslation } from '@lib/i18n'
import paramsUtils from '@lib/params'
import url from '@lib/url'
import { usePluginContext } from '@plugins/index'
import { useParams } from '@stores/params'

const Default = (): ReactElement => {
  const [params] = useParams()
  const { t } = useTranslation()
  const { enabled: isMoovitEnabled, handleBackToWallet } = useMoovitIntegration()
  const { trackPopupClick } = usePopupAnalytics(POPUP_TYPES.RESERVATION_ERROR, 'checkout')

  const navigate = useNavigate()

  const { hooks } = usePluginContext()

  // This should be replaced with the settings, the ticket will be created to introduce client data
  // such as name, homeUrl, etc.

  const externalUrl = hooks?.useHomeUrl?.()
  const internalUrl = url.build(['/'], paramsUtils.getPersistentUrlParams(params))

  const homePageCTALabel = t('checkout.reservationModal.homePage')
  const restartSearchCTALabel = t('checkout.reservationModal.restartSearch')
  const showHomePageButton = homePageCTALabel && homePageCTALabel.trim() !== ''

  const handleHomePageClick = () => {
    trackPopupClick(homePageCTALabel, POPUP_OUTCOMES.REDIRECT)
    if (externalUrl) {
      window.location.href = externalUrl
      return
    }
    isMoovitEnabled ? handleBackToWallet() : navigate(`/${internalUrl}`)
  }

  const handleRestartSearchClick = () => {
    trackPopupClick(restartSearchCTALabel, POPUP_OUTCOMES.REDIRECT)
    navigate(-1)
  }

  return (
    <>
      {showHomePageButton && (
        <div className="reservations-modal__buttons-home">
          <Button onClick={handleHomePageClick} color="white">
            <div className="reservations-modal__homepage-text">{homePageCTALabel}</div>
          </Button>
        </div>
      )}
      <div className="reservations-modal__buttons-restart">
        <Button onClick={handleRestartSearchClick}>{restartSearchCTALabel}</Button>
      </div>
    </>
  )
}

export default Default
